if (!customElements.get('product-quick-order')) {
  customElements.define(
    'product-quick-order',
    class ProductQuickOrder extends HTMLElement {
      constructor() {
        super();

        this.panel = this.querySelector('.product__quick-order-panel');
        this.openButtons = document.querySelectorAll('.product__quick-order');
        this.cancelButton = this.querySelector('.product__quick-order-cancel');
        this.submitButton = this.querySelector('.product__quick-order-submit');
        this.tabs = this.querySelectorAll('.product__quick-order-tab');
        this.quantityInputs = this.querySelectorAll('.product__quick-order-quantity');

        this.init();
      }

      init() {
        // Open panel
        this.openButtons.forEach(button => {
          button.addEventListener('click', this.open.bind(this));
        });

        // Close panel
        this.cancelButton?.addEventListener('click', this.close.bind(this));

        // Tab switching
        this.tabs.forEach(tab => {
          tab.addEventListener('click', this.switchTab.bind(this));
        });

        // Note: quantity-input component handles +/- buttons automatically
        // We just need to add to cart functionality

        // Add to cart
        this.submitButton?.addEventListener('click', this.addToCart.bind(this));
      }

      open() {
        if (this.panel) {
          this.panel.removeAttribute('hidden');

          // Reset all quantities to 0 when opening
          this.quantityInputs.forEach(input => {
            input.value = 0;

            // Update minus button state
            const minusButton = input.closest('quantity-input')?.querySelector('.minus');
            if (minusButton) {
              minusButton.classList.add('disabled');
            }
          });
        }
      }

      close() {
        if (this.panel) {
          this.panel.setAttribute('hidden', '');

          // Reset quantities to 0
          this.quantityInputs.forEach(input => {
            input.value = 0;

            // Update minus button state
            const minusButton = input.closest('quantity-input')?.querySelector('.minus');
            if (minusButton) {
              minusButton.classList.add('disabled');
            }
          });
        }
      }

      switchTab(e) {
        const clickedTab = e.target;
        const tabId = clickedTab.dataset.tab;

        // Remove active class from all tabs
        this.tabs.forEach(tab => tab.classList.remove('active'));

        // Add active class to clicked tab
        clickedTab.classList.add('active');

        // Hide all content sections
        const allContents = this.querySelectorAll('.product__quick-order-content');
        allContents.forEach(content => {
          content.setAttribute('hidden', '');
        });

        // Show the corresponding content
        const targetContent = this.querySelector(`[data-content="${tabId}"]`);
        if (targetContent) {
          targetContent.removeAttribute('hidden');
        }
      }

      addToCart() {
        const items = [];

        // Collect all items with quantity > 0
        this.quantityInputs.forEach(input => {
          const quantity = parseInt(input.value) || 0;
          if (quantity > 0) {
            items.push({
              id: input.dataset.variantId,
              quantity: quantity
            });
          }
        });

        if (items.length === 0) {
          alert('Please select at least one item');
          return;
        }

        // Add loading state to submit button
        this.submitButton.classList.add('loading');
        this.submitButton.setAttribute('disabled', 'disabled');

        const cartDrawer = document.querySelector('cart-drawer');
        const cartNotification = document.querySelector('cart-notification');
        const cart = cartDrawer || cartNotification;

        // Prepare request body
        const body = {
          items: items
        };

        // Prepare sections if cart is available
        let sectionsParam = '';
        if (cart) {
          sectionsParam = cart.getSectionsToRender().map((section) => section.id).join(',');
        }

        // Build URL with sections parameter
        const url = window.Shopify.routes.root + 'cart/add.js' +
          (sectionsParam ? `?sections=${sectionsParam}&sections_url=${window.location.pathname}` : '');

        // Add items to cart
        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(body)
        })
        .then(response => response.json())
        .then(response => {
          console.log('Items added to cart:', response);

          // Check for errors
          if (response.status || response.errors) {
            console.error('Error adding to cart:', response);
            alert(response.description || 'Error adding items to cart. Please try again.');

            // Remove loading state
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('disabled');
            return;
          }

          // Publish cart update event
          if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-quick-order',
              cartData: response
            });
          }

          // Render updated cart contents
          if (cart) {
            cart.renderContents(response);

            // Remove is-empty class from cart
            if (cart.classList.contains('is-empty')) {
              cart.classList.remove('is-empty');
            }
          }

          // Remove loading state
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('disabled');

          // Close panel (this will reset quantities to 0)
          this.close();
        })
        .catch((error) => {
          console.error('Error adding to cart:', error);
          alert('Error adding items to cart. Please try again.');

          // Remove loading state
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('disabled');
        });
      }
    }
  );
}
